import { useEffect, useState } from 'react';
import AdminService from '../../services/AdminService';
import Service from '../../types/Service';

export default function useAdminNodes(datastoreID: string) {
    const [loading, setLoading] = useState<boolean>(true);
    const [updating, setUpdating] = useState<boolean>(false);
    const [nodes, setNodes] = useState<Service[] | undefined>(undefined);
    const [error, setError] = useState<string | null>(null);

    const load = async () => {
        try {
            const result = await AdminService.getNodes(datastoreID);

            setNodes(result);
        } catch (err: any) {
            console.error(err);
            setError(err);
        }
    };

    const refresh = () => {
        const update = async () => {
            setUpdating(true);
            await load();
            setUpdating(false);
        };
        update();
    };

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await load();
            setLoading(false);
        };

        if (!nodes) {
            init();
        } else {
            refresh();
        }
    }, [datastoreID]);

    return { nodes, error, loading, refresh, updating };
}
